// extracted by mini-css-extract-plugin
export default {"soldOutLabel":"Nz7AnZ","container":"frcTbe"};